
declare let ga: Function;
declare let gtag: Function;

/**
 * Апи для работы с аналитикой
 */
export default class AnalyticsApi
{
    /**
     * Цели
     */
    private goalsNames: { [key: string]: string } = {
        'start_game': 'start_game',
    };

    /**
     * Массив названий переменных яндекс метрики
     */
    private metrikaCounters: Array<string> = [];

    constructor()
    {
    }

    /**
     * Отправка цели
     * @param goalId
     * @param params
     */
    public goal(goalId: string, params: { value?: number } | null = null): boolean
    {
        const goalName = this.goalsNames[goalId];

        if (!goalName) {
            AnalyticsApi.log('Goal name not found: ' + goalId);
            return false;
        }

        AnalyticsApi.log('Start send goal: ' + goalName);
        if (params) {
            AnalyticsApi.log('params:');
            AnalyticsApi.log(params);
        }

        try {
            /**
             * Отправляем в аналитику
             */
            if (typeof ga === 'function') {
                let goalParams: any = {
                    hitType: 'event',
                    eventCategory: goalName,
                    eventAction: 'reached'
                };
                if (params && params.value) {
                    goalParams['eventValue'] = params.value;
                }
                ga('send', goalParams);
                AnalyticsApi.log('Sent ' + goalName + ' to ga');
            }

            /**
             * Отправляем в аналитику - новый формат
             */
            if (typeof gtag === 'function') {
                let goalParams: any = {
                    'event_category': goalName
                };
                if (params && params.value) {
                    goalParams['value'] = params.value;
                }
                gtag('event', 'reached', goalParams);
                AnalyticsApi.log('Sent ' + goalName + ' to gtag');
            }

            AnalyticsApi.log('Finish send goal: ' + goalName);
        } catch (e) {
            AnalyticsApi.log(e);
        }

        return true;
    }

    /**
     * Логгирование
     * @param message
     */
    private static log(message: any): void
    {
        try {
            if (window.console) {
                console.log(message);
            }
        } catch (e) {
        }
    }

    public static getUid()
    {
        // @ts-ignore
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }
}
